import { Divider, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet } from 'react-native'
import MaterialIcons from 'react-native-vector-icons/MaterialIcons'
import { theme } from '../../../theme'

interface ReferentielHoraireProps {
  horaire: string | null
}

export const ReferentielHoraire: FunctionComponent<ReferentielHoraireProps> = ({ horaire }) => {
  if (!horaire) return null

  return (
    <>
      <View style={styles.horaireContainer}>
        <View style={styles.horaireLeftContainer}>
          <MaterialIcons name="event" size={20} color="black" />
        </View>
        <View style={styles.horaireInfoContainer}>
          <Text style={styles.horaireText}>{horaire}</Text>
        </View>
      </View>
      <Divider />
    </>
  )
}

const styles = StyleSheet.create({
  horaireContainer: {
    flexDirection: 'row',
    paddingVertical: theme.padding.x2,
    paddingHorizontal: theme.padding.x1,
    marginBottom: theme.padding.x2,
    marginTop: theme.padding.x2,
  },
  horaireLeftContainer: {
    marginRight: theme.padding.x1,
  },
  horaireInfoContainer: {
    flex: 1,
  },
  horaireText: {
    fontSize: theme.textSize.x1_75,
    paddingLeft: theme.padding.x05,
  },
})
